import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useHasSpeakers } from '../../../hooks/useHasSpeakers';

const MenuItems = ({ parentMenu, activeMenu }) => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const hasSpeakers = useHasSpeakers();

    const close = () => setOpenDropdown(null);

    return (
        <>
        <style>{`
            .mm-item { position: relative; }

            /* dropdown trigger arrow */
            .mm-has-drop > a::after {
                content: '\\f107';
                font-family: 'Font Awesome 5 Free';
                font-weight: 900;
                font-size: 10px;
                margin-left: 5px;
                opacity: 0.6;
                transition: transform 0.2s;
                display: inline-block;
            }
            .mm-has-drop.mm-open > a::after {
                transform: rotate(180deg);
            }

            /* dropdown panel */
            .mm-dropdown {
                position: absolute;
                top: 100%;
                left: 50%;
                transform: translateX(-50%);
                min-width: 200px;
                padding-top: 8px;
                z-index: 999;
            }
            .mm-dropdown__inner {
                background: rgba(10, 4, 20, 0.97);
                border: 1px solid rgba(255,255,255,0.1);
                border-radius: 12px;
                padding: 8px 0;
                box-shadow: 0 20px 50px rgba(0,0,0,0.6), 0 0 0 1px rgba(var(--eventflow-base-rgb),0.08);
                backdrop-filter: blur(16px);
                animation: ddFadeIn 0.18s ease;
            }
            @keyframes ddFadeIn {
                from { opacity: 0; transform: translateX(-50%) translateY(-6px); }
                to   { opacity: 1; transform: translateX(-50%) translateY(0); }
            }
            /* small arrow pointer */
            .mm-dropdown__inner::before {
                content: '';
                position: absolute;
                top: -5px; left: 50%;
                transform: translateX(-50%);
                width: 10px; height: 10px;
                background: rgba(10,4,20,0.97);
                border-left: 1px solid rgba(255,255,255,0.1);
                border-top: 1px solid rgba(255,255,255,0.1);
                transform: translateX(-50%) rotate(45deg);
            }
            .mm-dropdown__inner {
                position: relative;
            }
            .mm-dropdown__inner a {
                display: flex; align-items: center; gap: 10px;
                padding: 10px 18px;
                font-family: var(--eventflow-font);
                font-size: 14px; font-weight: 500;
                color: rgba(255,255,255,0.7) !important;
                text-decoration: none;
                transition: all 0.2s;
                white-space: nowrap;
            }
            .mm-dropdown__inner a i {
                font-size: 12px;
                color: var(--eventflow-base);
                width: 14px; text-align: center;
            }
            .mm-dropdown__inner a:hover {
                color: #fff !important;
                background: rgba(var(--eventflow-base-rgb),0.08);
                padding-left: 22px;
            }
            .mm-dropdown-divider {
                height: 1px;
                background: rgba(255,255,255,0.06);
                margin: 6px 0;
            }
        `}</style>

        <ul className="main-menu__list">
            {/* Home */}
            <li className={`mm-item${parentMenu === 'Home' ? ' current-menu-item' : ''}`}>
                <Link to="/" onClick={close}>Home</Link>
            </li>

            {/* CFP */}
            <li className={`mm-item${parentMenu === 'CFP' ? ' current-menu-item' : ''}`}>
                <Link to="/cfp" onClick={close}>CFP</Link>
            </li>

            {/* Trainings */}
            <li className={`mm-item${parentMenu === 'Trainings' ? ' current-menu-item' : ''}`}>
                <Link to="/trainings" onClick={close}>Trainings</Link>
            </li>

            {/* Schedule — dropdown: Speakers */}
            <li
                className={`mm-item mm-has-drop${openDropdown === 'schedule' ? ' mm-open' : ''}${parentMenu === 'Schedule' || parentMenu === 'Speakers' ? ' current-menu-item' : ''}`}
                onMouseEnter={() => setOpenDropdown('schedule')}
                onMouseLeave={close}
            >
                <Link to="/schedule" onClick={close}>
                    Schedule <i className="fa fa-angle-down" style={{fontSize:'10px',marginLeft:'4px',opacity:0.6,verticalAlign:'middle',transition:'transform 0.2s ease',transform: openDropdown === 'schedule' ? 'rotate(180deg)' : 'rotate(0deg)'}} />
                </Link>
                {openDropdown === 'schedule' && (
                    <div className="mm-dropdown">
                        <div className="mm-dropdown__inner">
                            <Link to="/schedule" onClick={close}><i className="fa fa-calendar-alt" />Full Schedule</Link>
                            {hasSpeakers && (
                                <Link to="/speakers" onClick={close}><i className="fa fa-microphone" />Speakers</Link>
                            )}
                        </div>
                    </div>
                )}
            </li>

            {/* CTF */}
            <li className={`mm-item${parentMenu === 'CTF' ? ' current-menu-item' : ''}`}>
                <Link to="/ctf" onClick={close}>CTF</Link>
            </li>

            {/* Community — dropdown: Events, Volunteers, About Us, Contact */}
            <li
                className={`mm-item mm-has-drop${openDropdown === 'community' ? ' mm-open' : ''}${parentMenu === 'Community' || parentMenu === 'Volunteers' || parentMenu === 'About' || parentMenu === 'Contact' ? ' current-menu-item' : ''}`}
                onMouseEnter={() => setOpenDropdown('community')}
                onMouseLeave={close}
            >
                <Link to="/community-events" onClick={close}>
                    Community <i className="fa fa-angle-down" style={{fontSize:'10px',marginLeft:'4px',opacity:0.6,verticalAlign:'middle',transition:'transform 0.2s ease',transform: openDropdown === 'community' ? 'rotate(180deg)' : 'rotate(0deg)'}} />
                </Link>
                {openDropdown === 'community' && (
                    <div className="mm-dropdown">
                        <div className="mm-dropdown__inner">
                            <Link to="/community-events" onClick={close}><i className="fa fa-users" />Community Events</Link>
                            <Link to="/volunteers" onClick={close}><i className="fa fa-hands-helping" />Volunteers</Link>
                            <div className="mm-dropdown-divider" />
                            <Link to="/about-us" onClick={close}><i className="fa fa-info-circle" />About Us</Link>
                            <Link to="/bsides-contact" onClick={close}><i className="fa fa-envelope" />Contact</Link>
                        </div>
                    </div>
                )}
            </li>
        </ul>
        </>
    );
};

export default MenuItems;
